import { createApp } from "vue";
import AdminSchoolRegistry from "./components/AdminSchoolRegistry.vue";
import SchoolRegistryGrid from "./components/SchoolRegistryGrid.vue";
import { readComparisonTable } from "./registryGrid.js";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-admin-school-registry]";

export function initAdminSchoolRegistryApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const comparisonTable = element.parentElement.querySelector("[data-registry-comparison-table]");
    if (comparisonTable) {
      const app = createApp(SchoolRegistryGrid, {
        ...readComparisonTable(comparisonTable),
        onReady: () => {
          comparisonTable.parentElement.hidden = true;
        },
      });
      app.mount(element);
      element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
      apps.push(app);
      continue;
    }
    const app = createApp(AdminSchoolRegistry, {
      apiUrl: payload.apiUrl || "/api/schools/registry",
      exportUrl: payload.exportUrl || "/api/schools/registry/export",
      perPage: payload.perPage || 50,
      regionOptions: Array.isArray(payload.regionOptions) ? payload.regionOptions : [],
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
